import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NbSecurityModule } from '@nebular/security';
import { MarkdownModule } from 'ngx-markdown';
import { IsAppRolesModule } from '~core/utils/app-roles/app-roles.module';
import { MetadataIoModule } from '~core/utils/metadata-io/metadata-io.module';
import { NoWhitespaceModule } from '~core/utils/no-whitespace/no-whitespace.module';
import { XmlPipe } from '~core/utils/xml.pipe';
import { SharedModule } from '../../shared/shared.module';
import { LicensesModule } from '../licenses/licenses.module';
import { ApplicationDetailsComponent } from './application-details/application-details.component';
import { ApplicationEditDialogComponent } from './application-edit/application-edit-dialog.component';
import { ApplicationEditPageComponent } from './application-edit/application-edit-page.component';
import { ApplicationEditComponent } from './application-edit/application-edit.component';
import { ApplicationEmailTemplatesComponent } from './application-email-templates/application-email-templates.component';
import { VariableListComponent } from './application-email-templates/variable-list/variable-list.component';
import { ApplicationUsersComponent } from './application-users/application-users.component';
import { ApplicationsRoutingModule } from './applications-routing.module';
import { ApplicationsComponent } from './applications.component';
import { MetadataDefinitionTabComponent } from './metadata-definition-tab/metadata-definition-tab.component';
import { MetadataSetsModule } from './metadata-set-tab/metadata-sets.module';
import { VersionsModule } from './versions/versions.module';

@NgModule({
  imports: [
    ApplicationsRoutingModule,
    ApplicationDetailsComponent,
    CommonModule,
    MarkdownModule.forChild(),
    FormsModule,
    ReactiveFormsModule,
    IsAppRolesModule,
    NoWhitespaceModule,
    NbSecurityModule,
    LicensesModule,
    MetadataIoModule,
    MetadataSetsModule,
    SharedModule,
    VersionsModule
  ],
  declarations: [
    ApplicationsComponent,
    MetadataDefinitionTabComponent,
    XmlPipe,
    ApplicationEditComponent,
    ApplicationEditDialogComponent,
    ApplicationEditPageComponent,
    ApplicationUsersComponent,
    ApplicationEmailTemplatesComponent,
    VariableListComponent
  ],
  exports: [
    MetadataDefinitionTabComponent,
    XmlPipe,
    ApplicationEditPageComponent,
    ApplicationUsersComponent
  ]
})
export class ApplicationsModule {}
